module.exports = __webpack_public_path__ + "img/eye-closed.d72fc0e9.svg";